<template>
 
    <v-list dense>

      <!-- Not expended -->
      <v-list-item 
        v-for="item in items"
        :color="soon.includes(item.title) ? '' : 'primary'"
        :key="item.title"
        :href="item.path === 'facebookPage' ? `https://www.facebook.com/sp0mTN` : ''"
        :to="item.path === 'facebookPage' ? '' : `/${$i18n.locale}/`+item.path"
        :disabled="soon.includes(item.title)"
        v-if="!item.isExpended"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t( "sidebar."+item.title ) }} <span style="font-size: x-small;" v-if="soon.includes(item.title)"> - {{ $t("sidebar.soon") }}</span></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Expended -->
      <v-list-group
        v-else
        :key="item.title"
        :prepend-icon="item.icon"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ $t( "sidebar."+item.title+".title" ) }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="subItem in item.items"
          :key="subItem.title"
          :to="`/${$i18n.locale}/`+subItem.path"
        >
          <v-list-item-content>
            <v-list-item-title>{{ $t( "sidebar."+item.title+"."+subItem.title ) }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-group>
      
    </v-list>
</template>

<script>

export default {

  name : 'items',

  data(){
    return {
      items: [
        { title: 'Scamas', icon: 'mdi-content-copy', path: 'dashboard' },
        { title: 'Victims', icon: 'mdi-account-multiple-outline', path: 'victims' },

        { isExpended : true,
          icon: 'mdi-checkbox-multiple-blank-outline',
          title: 'PrivateScama',
          items: [
            { title: 'Create' , path: 'private/create', icon: 'mdi-plus-circle-outline'},
            { title: 'Links' , path: 'private/index', icon: 'mdi-file-outline'},
          ],
        },

        { title: 'Settings', icon: 'mdi-account-settings-outline', path: 'settings' },
        { title: 'Contact', icon: 'mdi-message-text-outline' },
        { title: 'Facebook', icon: 'mdi-facebook', path: 'facebookPage' },
      ],
      soon : [
        'Contact',
      ],
    }
  }
};
</script>